import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: 'filterPipeExpenses'
})
export class FilterPipeExpenses implements PipeTransform {
    transform(expenses: any, term?: any): any {
        if (term === undefined) return expenses;
        if (term === null) return expenses;

        if (expenses != null) {
            return expenses.filter(function (expense) {
                if (expense.business_name != undefined)
                    if (expense.business_name.toString().toLowerCase().includes(term.toLowerCase()))
                        return expense;
                if (expense.concept != undefined)
                    if (expense.concept.toLowerCase().includes(term.toLowerCase()))
                        return expense;
                if (expense.number != undefined)
                    if (expense.number.toString().toLowerCase().includes(term.toLowerCase()))
                        return expense;
                if (expense.date != undefined)
                    if (moment(new Date(expense.date)).format("DD/MM/YYYY").toString().toLowerCase().includes(term.toLowerCase()))
                        return expense.date;
                if (expense.total != undefined)
                    if (expense.total.toString().toLowerCase().includes(term.toLowerCase()))
                        return expense;
                if (expense.payment_method != undefined)
                    if (expense.payment_method.toString().toLowerCase().includes(term.toLowerCase()))
                        return expense;
                // Buscar por IRPF porcentaje
                if (expense.irpf_percentage != undefined && expense.irpf_percentage != null)
                    if (expense.irpf_percentage.toString().toLowerCase().includes(term.toLowerCase()))
                        return expense;
                // Buscar por IRPF importe
                if (expense.irpf_amount != undefined && expense.irpf_amount != null)
                    if (expense.irpf_amount.toString().toLowerCase().includes(term.toLowerCase()))
                        return expense;

            })
        }

    }
}


// WEBPACK FOOTER //
// ./src/pages/income-expenses/expenses-create/filter.pipe.ts